// extracted by mini-css-extract-plugin
export default {"container":"styles__container___H9GhV","container-up":"styles__container-up___o0UwV"};